export default "__VITE_IMAGE_ASSET__3ee11671__";